import { useEffect, useState } from 'react';
import { fetchFlowsYears } from './flow_requests';

const buildContinuousYears = (minYear, maxYear) => {
  const start = Number(minYear);
  const end = Number(maxYear);

  if (!start || !end || start > end) {
    const current = new Date().getFullYear();
    return [String(current)];
  }

  const years = [];
  for (let y = start; y <= end; y += 1) {
    years.push(String(y));
  }
  return years;
};

export const useFinanceYearsRange = () => {
  const [yearsRange, setYearsRange] = useState(() => {
    const current = new Date().getFullYear();
    return [String(current)];
  });

  useEffect(() => {
    const loadYears = async () => {
      const currentYear = new Date().getFullYear();

      try {
        const response = await fetchFlowsYears();
        const flowsYears = response?.data?.years || [];

        if (!flowsYears.length) {
          setYearsRange([String(currentYear)]);
          return;
        }

        const minFlowYear = Math.min(...flowsYears);
        const maxFlowYear = Math.max(...flowsYears);

        const minYear = Math.min(minFlowYear, currentYear);
        const maxYear = Math.max(maxFlowYear, currentYear);

        setYearsRange(buildContinuousYears(minYear, maxYear));
      } catch (error) {
        console.error('Error loading finance years range:', error);
        const current = new Date().getFullYear();
        setYearsRange([String(current)]);
      }
    };

    loadYears();
  }, []);

  return yearsRange;
};

